<script>

import AppLoading from "@/components/elements/AppLoading.vue";
import {VesselService} from "@/services/VesselService";
import { toBlob } from 'dom-to-image-more';
import {mapActions, mapGetters} from "vuex";
import { PaginationMixin } from "@/mixins/PaginationMixin";
import loading from "@/components/elements/AppLoading.vue";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: 'SummaryPerNationalityBarGraph',
  mixins : [PaginationMixin, permissionMixin],
  components: {loading, AppLoading},
  data() {
    return {
      requestLoading : true,
      crewFilterType : [
        {
          name : 'Total Number of ONBOARD Crews',
          onboard : true,
        },
        {
          name : 'Total Number of Crews',
          onboard : false,
        },
      ],
      genderFilterType: [
        {
          name: 'All Genders',
          value: '',
        },
        {
          name: 'Male',
          value: 'Male',
        },
        {
          name: 'Female',
          value: 'Female',
        },
      ],
      genderFilter: '',
      selectedData : {
        country_id : 0,
        nationality_name : '',
        count : 0
      },
      filterIsOnboard : true,
      chartOptions: {
        chart: {
          type: "bar",
          events : {
            xAxisLabelClick: function(event, chartContext, config){
              const data = this.fullData[config.labelIndex];
              this.selectedData.country_id = data.id;
              this.selectedData.nationality_name = data.nationality;
              this.filterIsOnboard = true;
              if (!this.genderFilter) {
                this.selectedData.count = data.onboard_crew_count;
              } else if (this.genderFilter === 'Male') {
                this.selectedData.count = data.male_onboard_crew_count;
              } else {
                this.selectedData.count = data.female_onboard_crew_count;
              }
              this.getCrewNationality(1);
              $('#crew_nationality_modal').modal('show');
            }.bind(this),
            dataPointSelection: (event, chartContext, config) => {
              const data = this.fullData[config.dataPointIndex];
              this.selectedData.country_id = data.id;
              this.selectedData.nationality_name = data.nationality;
              this.filterIsOnboard = config.seriesIndex === 0;
              if (!this.genderFilter) {
                this.selectedData.count = this.filterIsOnboard
                  ? data.onboard_crew_count
                  : data.crew_count;
              } else if (this.genderFilter === 'Male') {
                this.selectedData.count = this.filterIsOnboard
                  ? data.male_onboard_crew_count
                  : data.male_crews;
              } else {
                this.selectedData.count = this.filterIsOnboard
                  ? data.female_onboard_crew_count
                  : data.female_crews;
              }
              this.getCrewNationality(1);
              $('#crew_nationality_modal').modal('show');
            }
          },
          toolbar: {
            tools: {
              download: false
            }
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
            barGap : 10,
            barSpacing : 5
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#000000', '#000000']
          }
        },
        title: {
          text: 'TOTAL CREW (PER NATIONALITY)',
          align: 'center'
        },
        colors: ['#01a1e7', '#C0C0C0'],
        legend: {
          position: "bottom",
        },
        xaxis: {
          categories: this.fullData.map(item => item.nationality),
        }
      }
    };
  },
  props : {
    fullData : {
      type : Array,
      default : []
    }
  },
  methods : {
    ...mapActions([
      'getCmsCrewNationality'
    ]),
    changeGenderFilter() {
      const data = this.fullData.find(
        item => item.id === this.selectedData.country_id
      );

      if (data) {
        if (!this.genderFilter) {
          this.selectedData.count = this.filterIsOnboard
            ? data.onboard_crew_count
            : data.crew_count;
        } else if (this.genderFilter === 'Male') {
          this.selectedData.count = this.filterIsOnboard
            ? data.male_onboard_crew_count
            : data.male_crews;
        } else {
          this.selectedData.count = this.filterIsOnboard
            ? data.female_onboard_crew_count
            : data.female_crews;
        }
      }

      this.pagination.currentPage = 1;
      this.getCrewNationality(1);
    },
    async getCrewNationality(page = 1) {
      this.requestLoading = true;
      await this.getCmsCrewNationality({
        country_id : this.selectedData.country_id,
        onboard : this.filterIsOnboard,
        gender: this.genderFilter,
        page : page
      });
      this.requestLoading = false;
    },
    resetPayload() {
      this.selectedData = {
        country_id : 0,
        nationality_name : '',
        count : 0
      }
      this.filterIsOnboard = true;
      this.genderFilter = '';
      this.pagination.currentPage = 1;
    },
    async getGraphImage() {
      swal.fire({
        'title': `Exporting Summary Per Nationality Graph`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/external-tal-revivo-tritone-tal-revivo/64/external-horizontal-bar-graph-chart-isolated-on-a-white-background-business-tritone-tal-revivo.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const blob = await toBlob(this.$refs["apex-chart-crew-per-nationality"].chart.el, {
        pixelRatio: 2,
        backgroundColor: 'white'
      });

      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'Summary Per Nationality of Crews');

      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`summary_per_nationality_of_crew_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    toggleNationalityTypeRequest() {
      const data = this.fullData.find(
        item => item.id === this.selectedData.country_id
      );

      if (!this.genderFilter) {
        this.selectedData.count = this.filterIsOnboard
          ? data.onboard_crew_count
          : data.crew_count;
      } else if (this.genderFilter === 'Male') {
        this.selectedData.count = this.filterIsOnboard
          ? data.male_onboard_crew_count
          : data.male_crews;
      } else {
        this.selectedData.count = this.filterIsOnboard
          ? data.female_onboard_crew_count
          : data.female_crews;
      }

      this.pagination.currentPage = 1;
      this.getCrewNationality(1);
    },
    setPage(page) {
      this.getCrewNationality(page)
    },
  },
  computed : {
    ...mapGetters([
      'crewNationalityList'
    ]),
    series() {
      if (!this.genderFilter) {
        return [
          {
            name: 'Total Number of ONBOARD Crews',
            data: this.fullData.map(item => item.onboard_crew_count)
          },
          {
            name: 'Total Number of Crews',
            data: this.fullData.map(item => item.crew_count)
          }
        ];
      }
      if (this.genderFilter === 'Male') {
        return [
          {
            name: 'Total Number Male ONBOARD Crews',
            data: this.fullData.map(item => item.male_onboard_crew_count)
          },
          {
            name: 'Total Number Male Crews',
            data: this.fullData.map(item => item.male_crews)
          }
        ];
      }
      return [
        {
          name: 'Total Number Female ONBOARD Crews',
          data: this.fullData.map(item => item.female_onboard_crew_count)
        },
        {
          name: 'Total Number Female Crews',
          data: this.fullData.map(item => item.female_crews)
        }
      ];
    }
  }
};
</script>


<template>
  <div class="card p-2 m-2">
    <div class="row mt-1">
      <div class="col-12" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
        <div class="d-flex align-items-center ml-2">
          <select class="form-control form-control-sm text-uppercase w-auto" v-model="filterIsOnboard" @change="toggleNationalityTypeRequest">
            <option v-for="item in crewFilterType" :key="item.name" :value="item.onboard">{{ item.name }}</option>
          </select>
          <select class="form-control form-control-sm text-uppercase w-auto mr-2" v-model="genderFilter" @change="changeGenderFilter">
            <option v-for="item in genderFilterType" :key="item.value" :value="item.value">{{ item.name }}</option>
          </select>
        </div>
        <button id="downloadSummaryOnBoardCrewChart" class="cursor-pointer float-right ml-2 e-btn e-btn-blue-gray force-white-all"
                @click="getGraphImage"
        >
          <font-awesome-icon class="mr-1" icon="download"/>
          Download Graph
        </button>
      </div>
    </div>

    <apexchart ref="apex-chart-crew-per-nationality" style="max-width: 100%; min-width: 100%" type="bar" height="400" :options="chartOptions"
               :series="series"></apexchart>

    <div class="modal fade" id="crew_nationality_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ selectedData.nationality_name }} ({{ selectedData.count }})</h5>
            <div class="d-flex align-items-center ml-2">
              <select class="form-control form-control-sm text-uppercase w-auto" v-model="filterIsOnboard" @change="toggleNationalityTypeRequest">
                <option v-for="item in crewFilterType" :key="item.name" :value="item.onboard">{{ item.name }}</option>
              </select>
              <select class="form-control form-control-sm text-uppercase w-auto mr-2" v-model="genderFilter" @change="changeGenderFilter">
                <option v-for="item in genderFilterType" :key="item.value" :value="item.value">{{ item.name }}</option>
              </select>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetPayload">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 75vh; overflow-y: auto">
            <div class="col-12">
              <div class="col-sm-auto p-0 m-0 mb-2">
                <nav aria-label="...">
                  <ul class="pagination text-smallest mb-0 pb-0">
                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                      <button class="page-link" @click="setPage(1)">First</button>
                    </li>

                    <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                      <button class="page-link" @click="setPage(page)">{{ page }}</button>
                    </li>

                    <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                      <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="table-responsive">
                <table class="small e-tbl ">
                  <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
                  <tr>
                    <th class="align-middle text-center" style="width: 1em" scope="col">#</th>
                    <th class="align-middle text-center" scope="col">CREW NAME</th>
                    <th class="align-middle text-center" scope="col">RANK</th>
                    <th class="align-middle text-center" scope="col">GENDER</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="requestLoading">
                    <td colspan="100%">
                      <loading></loading>
                    </td>
                  </tr>
                  <template v-else>
                    <tr class="text-uppercase" v-for="(data, index) in crewNationalityList">
                      <td class="align-middle text-center">{{ pagination.from + index }}</td>
                      <td class="align-middle text-center">{{ data.full_name }}</td>
                      <td class="align-middle text-center">{{ data.reliever_rank ?? data.rank }}</td>
                      <td class="align-middle text-center">{{ data.gender }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
::v-deep(.apexcharts-yaxis-label),
::v-deep(.apexcharts-bar-area),
::v-deep(.apexcharts-bar) {
  cursor: pointer;
}
</style>
